import React from 'react';
import { motion } from 'framer-motion';
import { PageHero } from '../../components/PageHero';
import { Link } from 'react-router-dom';
export function RestaurantsPage() {
  const restaurants = [{
    name: 'Jibek Jolu Flagship',
    cuisine: 'Elevated Central Asian',
    location: 'Downtown District',
    image: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=800&q=80',
    desc: 'Our original concept reimagined. Experience the rich tapestry of Silk Road flavors in a breathtaking modern setting.'
  }, {
    name: 'Oasis Grill',
    cuisine: 'Wood-fired Meats & Mezze',
    location: 'Westside Plaza',
    image: 'https://images.unsplash.com/photo-1544148103-0773bf10d330?w=800&q=80',
    desc: 'A lively, fire-forward dining experience focusing on premium cuts and vibrant sharing plates.'
  }, {
    name: 'Silk Road Tavern',
    cuisine: 'Craft Cocktails & Bites',
    location: 'Financial District',
    image: 'https://images.unsplash.com/photo-1514933651103-005eec06c04b?w=800&q=80',
    desc: 'An intimate space offering innovative mixology inspired by ancient spice routes.'
  }, {
    name: 'Nomad Cafe',
    cuisine: 'All-Day Dining & Bakery',
    location: 'North Hills',
    image: 'https://images.unsplash.com/photo-1554118811-1e0d58224f24?w=800&q=80',
    desc: 'A bright, welcoming neighborhood spot serving fresh pastries, specialty coffee, and hearty lunches.'
  }];
  return <div className="bg-white" data-id="element-729">
      <PageHero title="Our Restaurants" subtitle="Immersive dining experiences blending heritage with modern culinary techniques." backgroundImage="https://images.unsplash.com/photo-1559339352-11d035aa65de?w=1920&q=80" data-id="element-730" />

      <section className="py-24 md:py-32" data-id="element-731">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-732">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16" data-id="element-733">
            {restaurants.map((rest, idx) => <motion.div key={idx} className="group cursor-pointer" initial={{
            opacity: 0,
            y: 40
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.8,
            delay: idx * 0.1
          }} data-id="element-734">
                <div className="aspect-[4/3] overflow-hidden mb-8 relative rounded-sm" data-id="element-735">
                  <div className="absolute inset-0 bg-brand-dark/20 group-hover:bg-transparent transition-colors duration-500 z-10" data-id="element-736"></div>
                  <img src={rest.image} alt={rest.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out" data-id="element-737" />
                </div>

                <div className="flex flex-col md:flex-row md:items-start justify-between gap-6" data-id="element-738">
                  <div className="flex-1" data-id="element-739">
                    <h3 className="text-3xl font-serif text-brand-dark mb-2 group-hover:text-brand-red transition-colors" data-id="element-740">
                      {rest.name}
                    </h3>
                    <div className="flex items-center gap-3 text-xs uppercase tracking-widest text-brand-dark/50 font-medium mb-4" data-id="element-741">
                      <span data-id="element-742">{rest.cuisine}</span>
                      <span data-id="element-743">•</span>
                      <span data-id="element-744">{rest.location}</span>
                    </div>
                    <p className="text-brand-dark/70 font-light leading-relaxed" data-id="element-745">
                      {rest.desc}
                    </p>
                  </div>
                  <Link to="/company/contact" className="shrink-0 border-b border-brand-dark pb-1 text-sm uppercase tracking-widest hover:text-brand-red hover:border-brand-red transition-colors mt-2" data-id="element-746">
                    Visit Website
                  </Link>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>
    </div>;
}